import type { ProfileData } from '@/hooks/use-profile'

export function getProfileInitials(p: ProfileData | null | undefined): {
  initials: string
  colorSeed: string
  useSilhouette: boolean
} {
  if (!p) {
    return { initials: '', colorSeed: '', useSilhouette: true }
  }
  const a = (p.first_name || '').trim()
  const b = (p.last_name || '').trim()
  if (a || b) {
    const s = `${a[0] || ''}${b[0] || ''}`.toUpperCase()
    if (!s) {
      return {
        initials: '',
        colorSeed: String(p.id ?? p.email ?? 'profile'),
        useSilhouette: true,
      }
    }
    return {
      initials: s,
      colorSeed: (p.id ?? p.email ?? s) || s,
      useSilhouette: false,
    }
  }
  const parts = (p.full_name || '').trim().split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    const s = `${parts[0][0] || ''}${parts[parts.length - 1][0] || ''}`.toUpperCase()
    return {
      initials: s,
      colorSeed: (p.id ?? p.email ?? s) || s,
      useSilhouette: false,
    }
  }
  if (parts.length === 1) {
    const ch = parts[0][0]
    if (ch) {
      return {
        initials: ch.toUpperCase(),
        colorSeed: (p.id ?? p.email ?? ch) || ch,
        useSilhouette: false,
      }
    }
  }
  return { initials: '', colorSeed: String(p.id ?? p.email ?? 'profile'), useSilhouette: true }
}
